export default {"src":"/_next/static/media/Minus.be8a9a3f.svg","height":24,"width":24};